export default "__VITE_ASSET__BAx0aBEU__"